// NOTE: These values are hard-coded in Web Proxy and must match the route set there.
// The /fep/api route here should enable various product pages to be able to POST
// back to a consistent endpoint.

// NOTE: Ensure you also update the Cypress tests to intercept the correct paths
// See tests inside: cypress/cypress/e2e/pdp/*

export const SHOP_PROXY_PUBLIC_ENDPOINT = '/fep/api/shop-bff';
export const MESSAGES_PUBLIC_ENDPOINT = '/fep/api/messages';

export const ACCEPTED_PREVIEW_TYPES = [
  'primary',
  'supplementary',
  'supplementary2',
  'supplementary3',
  'supplementary4',
  'supplementary5',
  'artwork',
];

export const PDP_LEADING_IMAGE_EXPERIMENT_PRODUCTS = [
  'billowing-parachute',
  'blockish-wrapper',
  'cactus-bizzo',
  'calm-wrapper',
  'cheeky-cockatoo',
  'chrissy-chungus',
  'cluey-kookaburra',
  'dinkum-bandicoot',
  'flaming-ute',
  'peckish-flannel',
  'ripper-rissole',
  'sooky-sanga',
  'unreal-chinwag',
  'wonky-mozzie',
];

export enum PreviewStyle {
  DEFAULT = 'default',
  CLOSE_PREVIEW = 'product_close',
  ALTERNATE_PRODUCT_CLOSE = 'alternate_product_close',
  PRIMARY_SQUARE = 'primary_square',
}

export const SIMILAR_DESIGNS_LIMIT = 32;
export const SIMILAR_DESIGNS_SEO_LINK_LIMIT = 16;

export const DD_PDP_ERROR_METRIC_NAME = 'frontend.pdp.error.count';
